"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        padding: 7,
        backgroundColor: theme.grey9,
        borderRadius: '3px 3px 0 0',
        borderBottom: `1px solid ${theme.grey4}`
    },
    button: {
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
        overflow: 'hidden',
        outline: 'none',
        minHeight: 24,
        '&[disabled]': {
            cursor: 'default'
        },
        '[aria-busy=true] &[disabled]': {
            cursor: 'wait'
        }
    },
    avatar: {
        width: 24,
        flexShrink: 0,
        marginRight: 7
    },
    name: {
        fontSize: 14,
        fontWeight: 700,
        lineHeight: '18px',
        minWidth: 0,
        color: theme.grey1
    },
    truncate: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    }
});
//# sourceMappingURL=atc.group.header.style.js.map